import type { ComponentProps } from "react";

import { connect, mapProps, mapReadPretty } from "@formily/react";
import { Input, Tooltip } from "antd";

import styles from "./CallNotesField.module.scss";

type TextAreaProps = ComponentProps<typeof Input.TextArea>;

function CallNotesReadPretty({ value }: { value?: string | null }) {
	const text = value == null || value === "" ? "" : String(value);

	if (!text) {
		return <span className={styles.empty}>—</span>;
	}

	return (
		<Tooltip
			title={<div className={styles.tooltipBody}>{text}</div>}
			placement="topLeft"
			mouseEnterDelay={0.1}
			trigger={["hover"]}
			styles={{ root: { maxWidth: 480 } }}
			getPopupContainer={() => document.body}
		>
			<div className={styles.trigger}>
				<div className={styles.clamped}>{text}</div>
			</div>
		</Tooltip>
	);
}

function CallNotesTextAreaInner(props: TextAreaProps) {
	return <Input.TextArea rows={4} {...props} />;
}

/** patient_call Call Notes / Follow Up Note — TextArea (4 rows); read mode clamps + tooltip. */
export const CallNotesField = connect(
	CallNotesTextAreaInner,
	mapProps({ readOnly: "readOnly" }),
	mapReadPretty(CallNotesReadPretty)
);
